<script>
  import { hooksStore } from "../../../stores/hooks.store";
  import { tempStore } from "../../../stores/temp.store";

  // vkladam ikonku a funkcionalitu pre tlac
  import PrintControl from "./ControlsPrint/controlsPrint";
  // vkladam draw plugin a jeho upravy
  import { Draw, mapboxDraw } from "./mapboxDraw";
  // tooltip component - zobrazenie aktualne kreslenej dlzky, ...
  import Tooltip from "./mapboxDraw/Tooltip.svelte";

  import { tooltipData } from "./mapboxDraw/createTooltip";

  import center from "@turf/center";
  import { get as get_store } from "svelte/store";

  import { getMap } from "../../../helpers/map";
  import { vratDataZPrieniku } from "../../../api/intersect";
  import get from "get-value";
  import set from "set-value";

  const map = getMap();

  hooksStore.addAction("drawDeselect", "Constrols.svelte", () => {
    Draw.changeMode("simple_select");
  });

  // navigacne ikonky vlavo hore
  map.addControl(
    new maplibregl.NavigationControl({
      showCompass: true,
      visualizePitch: true,
    }),
    "top-left"
  );

  // mierka vlavo dole
  map.addControl(
    new maplibregl.ScaleControl({
      maxWidth: 120,
      unit: "metric",
    }),
    "bottom-left"
  );

  // pridavam cely draw do mapy
  map.addControl(mapboxDraw, "bottom-right");

  document.querySelector(".mapbox-gl-draw_line").setAttribute("title", "Línia");
  document
    .querySelector(".mapbox-gl-draw_polygon")
    .setAttribute("title", "Polygón");
  document
    .querySelector(".mapbox-gl-draw_polygon2")
    .setAttribute("title", "Obdĺžnik");
  document.querySelector(".mapbox-gl-draw_point").setAttribute("title", "Bod");
  document
    .querySelector(".mapbox-gl-draw_trash")
    .setAttribute("title", "Zmazať");

  map.on("draw.update", async function (e) {
    drawAction(e, "update");
  });
  map.on("draw.create", async function (e) {
    drawAction(e, "create");
  });
  map.on("draw.delete", async function (e) {
    drawAction(e, "delete");
  });
  map.on("draw.selectionchange", async function (e) {
    drawAction(e, "selectionchange");
  });

  async function drawAction(e, action) {
    hooksStore.doAction("zmazatVsetkyPopupOkna");
    let tooltip = document.getElementById("tooltip");
    tooltip.innerHTML = "";
    tooltip.style.display = "none";

    if (e.features.length && action !== "delete") {
      const centerPoint = center(e.features[0]);

      const response = await vratDataZPrieniku({
        layer: e.features[0].geometry,
        radius: false,
      });
      const data = get(response, "data", false);
      let obsah;
      if (data) {
        data.map((item) => {
          item.layer = e.features[0].geometry;
        });
        obsah = hooksStore.applyFilters("vygenerujObsahPopup", data);
        set(e, "features.0.properties.description", obsah);

        const sysType = get(e, "features.0.properties.sysType");
        const sysData = tooltipData(get(e, "features"), sysType, false, true);

        Draw.setFeatureProperty(e.features[0].id, "description", obsah);
        Draw.setFeatureProperty(e.features[0].id, "sysData", sysData);
        Draw.add(Draw.get(e.features[0].id));

        if (Draw.getMode() !== "direct_select") {
          hooksStore.doAction(
            "zobrazPopUpOkno",
            centerPoint.geometry.coordinates,
            obsah,
            {
              type: "FeatureCollection",
              features: e.features,
            },
            e.features[0].id
          );
        }
      }
    }
    let store = get_store(tempStore);
    const aktivneKreslenia = Draw.getAll();
    set(store, "kreslenia", aktivneKreslenia);
    tempStore.set(store);
  }

  const print = new PrintControl();
  map.addControl(print, "bottom-left");

  function vymazatKreslenia() {
    console.log("vymazane");
  }
</script>

<Tooltip />
